import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiResponse } from '@card-software/library';
import { environment } from '../../environments/environment';
import { ConfirmMatchesCommand, ReconciliationResult } from '../models/bank-reconciliation/bank-reconciliation';

@Injectable({ providedIn: 'root' })
export class BankReconciliationProxyService {
  private readonly httpClient = inject(HttpClient);
  private readonly baseUrl = environment.proxyUrls.financeApi + '/api/v1/bank-reconciliation';

  public match(file: File, bankAccountId: string): Observable<ApiResponse<ReconciliationResult>> {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('bankAccountId', bankAccountId);
    return this.httpClient.post<ApiResponse<ReconciliationResult>>(`${this.baseUrl}/match`, formData);
  }

  public confirm(command: ConfirmMatchesCommand): Observable<ApiResponse<number>> {
    return this.httpClient.post<ApiResponse<number>>(`${this.baseUrl}/confirm`, command);
  }
}
